import Activity from './Activity';
import { QuizQuestion } from '../ActivityProgress';
import { CodeEditorActivity } from '../CodeEditorActivity';
import { ColumnDND } from '../DNDOrdenation';
import MultipleChoiceAnswer from '../MultipleChoiceAnswer';

export interface ChallengeActivity extends Activity {
  questions: TextActivityElement[];
}

/**
 * @deprecated Use `QuestionTypeEnum` from `@/models/Question` instead.
 */
export enum ActivityTypeEnum {
  QUIZ = 'QUIZ',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  CODE = 'CODE',
  TRUE_OR_FALSE = 'TRUE_OR_FALSE',
  DND_ORDENATION = 'DND_ORDENATION',
  DND_POSITIONAL = 'DND_POSITIONAL',
  CODE_EDITOR = 'CODE_EDITOR',
  BLOCK = 'BLOCK',
}

export type changeStatus = 'new' | 'edit' | 'changed';

/**
 * @deprecated Use `Question` from `@/models/Question` instead.
 */
export default interface ActivityElement {
  id: number;
  identifier: string;
  questionId?: number;
  title?: string;
  type: ActivityTypeEnum;
  activityProgressUrl?: string;
  activity?: number;
  progressId?: number;
  order: number;
  changeStatus?: changeStatus;
  quizQuestions?: MultipleChoiceAnswer[];
}

export enum VideoPlayerEnum {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
}

export interface ErrorList {
  identifier: string;
  errors: string[];
}

export interface TextActivityElement extends ActivityElement {
  title: string;
  subtitle: string;
  content: string;
}

export interface CodeActivityElement extends ActivityElement {
  title: string;
  instructions: string;
  map: object;
  isValidated?: boolean;
  tip?: string;
  maxBlocks?: number;
}
export interface BlockCodeActivityElement extends ActivityElement {
  title: string;
  instructions: string;
  tip?: string;
  maxBlocks?: number;
  initialCode: string;
  initialWorkspace: object;
}

export interface VideoActivityElement extends ActivityElement {
  videoPlayer: VideoPlayerEnum;
  url: string;
  title: string;
  subtitle: string;
  width?: number;
  height?: number;
}

export interface TrueOrFalseActivityElement extends ActivityElement {
  question: string;
  isTrue: boolean;
  reason: string;
  content: string;
}

export enum QuizAnswersType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
}

export interface QuizActivityElement extends ActivityElement {
  question: string;
  quizAnswers: MultipleChoiceAnswer[] | QuizQuestion[];
  reason: string;
  hasStepper: boolean;
  content?: string;
  answerType: QuizAnswersType;
}

export type CodeActivityGoal = {
  coins: number;
  checkpoints: number;
};

export interface CodeActivityEditElement extends CodeActivityElement {
  teacherCode: object;
  goal: CodeActivityGoal;
}

export interface BlockCodeActivityEditElement extends BlockCodeActivityElement {
  solutionCode: string;
  solutionWorkspace: object;
  isValidated: boolean;
  expectedOutput: string;
}

export interface QuizActivityEditElement extends QuizActivityElement {
  quizAnswers: MultipleChoiceAnswer[];
}

export interface DNDOrdenationActivity extends ActivityElement {
  title: string;
  subtitle: string;
  columns: ColumnDND[];
}

export interface DNDPositionalActivity extends ActivityElement {
  title: string;
  subtitle: string;
  questionColumn: any;
  answerColumn: any;
}

export type CodeEditorActivityElement = ActivityElement & CodeEditorActivity;
